import React, { useState } from "react";
import { Button, Icon } from "tabler-react";
import * as conf from "../../config/config";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import * as XLSX from "xlsx";

const HEADERS = ["id_movimiento", "envio", "estatus", "id_sap", "moneda", "tarifa", "aplico_descuento", "porcentaje_descuento", "nota_credito", "imputable", "folio_factura"];

const CargaMasiva = () => {
  const [preview, setPreview] = useState([]);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [resultado, setResultado] = useState(null);

  const handleFile = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    setResultado(null);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { header: HEADERS, defval: "" });
      // Quitar header row y filas vacías
      const rows = json.slice(1).filter(row => row.id_movimiento !== "" && row.id_movimiento !== 0);
      setPreview(rows);
    };
    reader.readAsArrayBuffer(selectedFile);
  };

  const confirmar = () => {
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    axios.post(
      conf.api_raiz + "movimientos-facturar/carga-masiva",
      formData,
      { headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer " + sessionStorage.getItem("tok") } }
    ).then((res) => {
      setUploading(false);
      setResultado(res.data);
      if (res.data.success) {
        NotificationManager.success(`Se cargaron ${res.data.insertados} registros`);
      } else {
        NotificationManager.error(res.data.error || "Error en la carga");
      }
    }).catch(() => {
      setUploading(false);
      NotificationManager.error("Error al subir archivo");
    });
  };

  const cancelar = () => {
    setPreview([]);
    setFile(null);
    setResultado(null);
  };

  return (
    <div style={{ padding: "20px", maxHeight: "70vh", overflowY: "auto" }}>
      <h5>Carga Masiva de Facturación</h5>

      {preview.length === 0 && !resultado && (
        <>
          <p className="text-muted" style={{ fontSize: "12px" }}>Sube un archivo <strong>.xlsx</strong> o <strong>.csv</strong> con las siguientes columnas en orden:</p>
          <div style={{ overflowX: "auto" }}>
            <table className="table table-sm table-bordered" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>
              <thead className="thead-light">
                <tr>
                  {HEADERS.map(h => <th key={h}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1234567</td><td>true</td><td>Alojado</td><td>0-001</td><td>USD</td>
                  <td>25.50</td><td>si</td><td>40</td><td></td><td>Patios</td><td>A254</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-muted" style={{ fontSize: "11px" }}>
            <strong>envio:</strong> true/false/si/no &nbsp;|&nbsp;
            <strong>estatus:</strong> Alojado, Finalizado, En ruta, No facturable, Pendiente, OV &nbsp;|&nbsp;
            <strong>moneda:</strong> USD, MXN
          </p>
          <hr />
          <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFile} />
        </>
      )}

      {preview.length > 0 && !resultado && (
        <>
          <div className="alert alert-info" style={{ fontSize: "12px" }}>
            <strong>{preview.length}</strong> registros encontrados. Revisa la vista previa y confirma la carga.
          </div>
          <div style={{ overflowX: "auto", maxHeight: "40vh", overflowY: "auto" }}>
            <table className="table table-sm table-bordered table-striped" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>
              <thead className="thead-dark">
                <tr>
                  {HEADERS.map(h => <th key={h}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {preview.map((row, i) => (
                  <tr key={i}>
                    {HEADERS.map(h => <td key={h}>{String(row[h] ?? "")}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-3 text-right">
            <Button color="secondary" className="mr-2" onClick={cancelar}>Cancelar</Button>
            <Button color="primary" onClick={confirmar} disabled={uploading}>
              {uploading ? "Guardando..." : "Confirmar y Guardar"}
            </Button>
          </div>
        </>
      )}

      {resultado && (
        <div className={`alert ${resultado.success ? "alert-success" : "alert-danger"} mt-3`}>
          {resultado.success ? (
            <span><strong>{resultado.insertados}</strong> registros cargados correctamente.</span>
          ) : (
            <span>Error: {resultado.error}</span>
          )}
          {resultado.errores && resultado.errores.length > 0 && (
            <ul className="mt-2 mb-0" style={{ fontSize: "11px" }}>
              {resultado.errores.map((err, i) => <li key={i}>{err}</li>)}
            </ul>
          )}
          <div className="mt-3">
            <Button size="sm" color="secondary" onClick={cancelar}>Cargar otro archivo</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CargaMasiva;
